import { render } from "./collapse.vue?vue&type=template&id=38daa68e&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=38daa68e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38daa68e"

export default script